<script setup>
import { getCookie, actionPermission, directToRPGUserSystem } from '../methods';

const openLoginUrl = () => {
  const isLink = getCookie('rpg_temp_token_is_link') === 'true';
  if (isLink) {
    directToRPGUserSystem(true);
  } else {
    directToRPGUserSystem(false);
  }
};
</script>

<template>
  <div class="modal-body">
    <div class="mt-4 mb-2">
      <h4 class="text-center mb-3">
        綁定/登入 RPG 帳號，即可評價課程
      </h4>
      <div class="d-flex justify-content-center">
        <button
          v-if="!actionPermission"
          @click="openLoginUrl"
          class="btn btn-dark px-4 rounded-0 ms-2"
        >
          <span v-if="!(getCookie('rpg_temp_token_is_link') === 'true')">綁定</span>
          <span v-else>登入</span>
          RPG 帳號
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.starIcon{
   color: #5dba83;
}
.starIcon:hover, .starIcon:focus, .starIcon:active {
  color: #4a9569;
}
</style>,
  onMounted
